<div class="login-container">
  <!-- Header -->
  <header class="login-header">
    <div class="header-left">
    </div>
    <div class="header-right">
      <img
        *ngIf="isChristmasMode"
        src="../../../assets/img/sispac-new/colorida-com-escrita-verde.png"
        alt="CGE e Governo de Goiás"
        class="header-logo">
      <img
        *ngIf="!isChristmasMode"
        src="../../../assets/img/sispac-new/colorida-com-escrita-verde.png"
        alt="CGE e Governo de Goiás"
        class="header-logo">
    </div>
  </header>

  <!-- Main Content -->
  <main class="login-main">
    <div class="login-content">
      <!-- SISPAC Logo and Title -->
      <div class="sispac-logo-section">
        <div class="sispac-logo-container">
          <div class="sispac-logo">
            <img
              *ngIf="isChristmasMode"
              src="../../../assets/img/christmas/Gemini_Generated_Image_rcto20rcto20rcto-removebg-preview.png"
              alt="Logo Natal"
              class="logo-image">
            <img
              *ngIf="!isChristmasMode"
              src="../../../assets/img/sispac-new/logo-sispac-new.png"
              alt="SISPAC Logo"
              class="logo-image">
          </div>
          <div class="sispac-title">

            <img
              *ngIf="!isChristmasMode"
              src="../../../assets/img/sispac-new/nome-sispac-new.png"
              alt="SISPAC"
              class="title-image">
          </div>
        </div>
        <p class="system-description">
          Sistema de Controle de Procedimentos Administrativos Correcionais - SISPAC
        </p>
      </div>

      <!-- Login Form Card -->
      <div class="login-form-card">
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="login-form">
          <div class="form-field">
            <label for="username">Usuário (CPF)</label>
            <input
              id="username"
              type="text"
              placeholder="Digite seu CPF"
              mask="000.000.000-00"
              formControlName="login"
              class="form-input"
            >
            <div class="error-message" *ngIf='userForm.controls.login.hasError("minlength") && userForm.controls.login.touched'>
              CPF inválido
            </div>
            <div class="error-message" *ngIf='userForm.controls.login.hasError("required") && userForm.controls.login.touched'>
              Campo obrigatório
            </div>
          </div>

          <div class="form-field">
            <label for="password">Senha</label>
            <div class="password-input-container">
              <input
                id="password"
                [type]="hidePassword ? 'password' : 'text'"
                placeholder="Digite sua senha"
                formControlName="password"
                class="form-input"
              >
              <button
                type="button"
                class="password-toggle"
                (click)="togglePasswordVisibility()"
              >
                <i class="material-icons">{{hidePassword ? 'visibility_off' : 'visibility'}}</i>
              </button>
            </div>
            <div class="error-message" *ngIf='userForm.controls.password.hasError("required") && userForm.controls.password.touched'>
              Campo obrigatório
            </div>
          </div>

          <!-- Forgot Password Link -->
          <div class="forgot-password-section">
            <button
              type="button"
              class="forgot-password-link"
              (click)='reenviarSenha()'
              [disabled]='userForm.controls.login.invalid || isProgress'
            >
              Reenviar senha
            </button>
          </div>

          <!-- Loading indicator -->
          <div *ngIf='isProgress' class="progress-section">
            <div class="progress-bar">
              <div class="progress-fill"></div>
            </div>
            <p>Aguarde...</p>
          </div>

          <!-- Login Button -->
          <button
            type="submit"
            class="login-button"
            [disabled]="isProgress"
          >
            Entrar
          </button>

          <!-- Account Access Link -->
          <div class="account-access-section">
            <button
              type="button"
              class="account-access-link"
              (click)="acessarConta()"
            >
              Acesse sua conta
            </button>
          </div>
        </form>
      </div>
    </div>
  </main>

  <!-- Footer with Wave Design -->
  <footer class="login-footer">
    <div class="footer-wave">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" class="shape-fill"></path>
        <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.71,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" class="shape-fill"></path>
        <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" class="shape-fill"></path>
      </svg>
    </div>
    <div class="footer-content">
      <span class="footer-text">Subcontroladoria do Sistema de Correição e Contas</span>
    </div>
  </footer>
</div>
